import React from 'react';
import { Controller } from 'react-hook-form';
import ErrorMessage from 'app/BargainWidget/Bargains/WidgetV1/components/forms/ErrorMessage';

const CustomerPhoneFieldV1 = ({ label, placeholder, control, widgetSettings }) => {
  return (
    <Controller
      name="phone"
      control={control}
      render={({ field: { value, onChange, ...field }, fieldState }) => (
        <div className="bargain-widget-v1-phone-field-block">
          <label
            style={{ '--form-label-text-color': widgetSettings?.contentFormLabelColor || '#4b5563' } as any}
            className="se-text-xs se-font-medium se-text-[var(--form-label-text-color)] se-mb-1.5 se-block bargain-widget-v1-input-field-label"
          >
            {label}
          </label>
          <input
            {...field}
            type="number"
            value={value}
            onChange={e => onChange(e.target.value)}
            className="se-w-full se-bg-gray-50 se-border-none se-rounded-xl se-px-4 se-py-2.5 focus:se-outline-none focus:se-ring-2 focus:se-ring-indigo-500/20 se-text-gray-800 se-text-sm se-transition-all se-duration-200 bargain-widget-v1-phone-field"
            placeholder={placeholder}
          />
          <ErrorMessage fieldState={fieldState} />
        </div>
      )}
    />
  );
};

export default CustomerPhoneFieldV1;
